<template>
  <div class="py-6 px-8">
    <h-header :title="title" />

    <CityListFilters />

    <v-card outlined>
      <v-data-table
        disable-sort
        hide-default-footer
        mobile-breakpoint="20"
        :headers="headers"
        :items="cities"
        :loading="isCitiesLoading"
        :items-per-page="itemsPerPage"
        :no-data-text="$t('table.noResults')"
        :loading-text="$t('table.loading')"
        @dblclick:row="showCityRow"
        class="clickable"
      >
        <template #[`item.enabled`]="{ item }">
          <v-chip :color="item.enabled ? 'primary' : ''" small>
            <span>
              {{
                item.enabled
                  ? $t('city.label.enabled')
                  : $t('city.label.disabled')
              }}
            </span>
          </v-chip>
        </template>

        <template #[`item.actions`]="{ item }">
          <v-row no-gutters>
            <v-col>
              <v-icon small @click="openUpdateModal(item.id)"
                >mdi-pencil</v-icon
              >
            </v-col>
            <v-col>
              <v-icon small @click="showCity(item)"> mdi-eye </v-icon>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card>

    <RightDrawer :moreInfo="false">
      <CityOverview :city="details" />
    </RightDrawer>

    <CityUpdate ref="updateCityModal" />

    <h-pagination :fetch="fetchCitiesPaginated" />
  </div>
</template>
<script>
import CityListFilters from '@/components/city/CityListFilters'
import CityUpdate from '@/components/city/CityUpdate'
import CityOverview from '@/components/city/CityOverview'
import RightDrawer from '@/components/app/RightDrawer'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { cityHeaders } from './listHeaders/cityHeaders'
import router from '@/router'
import { handleParams } from '@/util/routes'

export default {
  name: 'CityList',

  components: { CityListFilters, CityUpdate, RightDrawer, CityOverview },

  data() {
    return {
      title: router.currentRoute.name,
      headers: cityHeaders,
      details: {},
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'isCitiesLoading', 'cities', 'itemsPerPage']),
  },

  methods: {
    ...mapActions(['fetchCitiesPaginated']),

    ...mapMutations(['setIsDrawerOpen']),

    openUpdateModal(cityId) {
      this.$refs.updateCityModal.openModal(cityId)

      handleParams('cities', cityId)
    },

    showCity(item) {
      this.setIsDrawerOpen(true)
      this.details = item
    },

    showCityRow(event, { item }) {
      this.showCity(item)
    },
  },

  mounted() {
    this.fetchCitiesPaginated()
  },
}
</script>
